import { ClerkAuthWrapper } from "./ClerkAuthWrapper";

export function SignUpForm() {
  return <ClerkAuthWrapper mode="signup" />;
}
